
import React, { Component } from 'react';
import { Form, Segment, Button, Divider } from 'semantic-ui-react';
import Select from 'react-select';
import axios from 'axios'
import { serverIp, } from '../../../../config/constants.js'
import * as UiConsts from '../../../../config/UiConstants.js'
import { getShirtTypesToDisplay } from '../LargeProjects/ApiUtils'


class RecItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            items:[],
            // items: [

            //     {
            //         "category": "selectedItem",
            //         "label": "t_shirt",
            //         "value": "t_shirt",
            //         "item_id": '1474236000000066216',
            //         "rate": 35000,
            //         "quantity": 1
            //     },
            //     {
            //         "category": "selectedItem",
            //         "label": "jersey",
            //         "value": "football_jersey",
            //         "item_id": '1474236000000066254',
            //         "rate": 40000,
            //         "quantity": 1
            //     },
            //     {
            //         "category": "selectedItem",
            //         "label": "phoneCase",
            //         "value": "phoneCase",
            //         "item_id": '1474236000000717055',
            //         "rate": 50000,
            //         "quantity": 1
            //     },
            //     {
            //         "category": "selectedItem",
            //         "label": "jumper",
            //         "value": "jumper",
            //         "item_id": '1474236000000066417',
            //         "rate": 60000,
            //         "quantity": 1
            //     },
            //     {
            //         "category": "selectedItem",
            //         "label": "cranes",
            //         "value": "cranes",
            //         "item_id": '1474236000000089001',
            //         "rate": 40000,
            //         "quantity": 1
            //     },

            //     {
            //         "category": "selectedItem",
            //         "label": "cap",
            //         "value": "cap",
            //         "item_id": '1474236000000089010',
            //         "rate": 25000,
            //         "quantity": 1
            //     },
            //     {
            //         "category": "selectedItem",
            //         "label": "cup",
            //         "value": "cup",
            //         "item_id": '1474236000000106012',
            //         "rate": 45000,
            //         "quantity": 1
            //     },
            //     {
            //         "category": "selectedItem",
            //         "label": "pillow",
            //         "value": "pillow",
            //         "item_id": '1474236000000191089',
            //         "rate": 40000,
            //         "quantity": 1
            //     },
            //     {
            //         "category": "selectedItem",
            //         "label": "plain_jersey",
            //         "value": "plain_jersey",
            //         "item_id": '1474236000000106003',
            //         "rate": 30000,
            //         "quantity": 1
            //     },
            //     {
            //         "category": "selectedItem",
            //         "label": "robe",
            //         "value": "robe",
            //         "item_id": '1474236000000233411',
            //         "rate": 90000,
            //         "quantity": 1
            //     },
            //     {
            //         "category": "selectedItem",
            //         "label": "baby_cloth",
            //         "value": "baby_cloth",
            //         "item_id": 1474236000000101080,
            //         "rate": 45000,
            //         "quantity": 1
            //     },
            //     {
            //         "category": "selectedItem",
            //         "label": "printing_only",
            //         "value": "printing_only",
            //         "item_id": '1474236000000115057',
            //         "rate": 15000,
            //         "quantity": 1
            //     },
            //     // {
            //     //     "category": "selectedItem",
            //     //     "label": "flag",
            //     //     "value": "flag",
            //     //     "item_id": '1474236000000233420',
            //     //     "rate": 100000,
            //     //     "quantity": 1
            //     // },
            //     {
            //         "category": "selectedItem",
            //         "label": "night_gown",
            //         "value": "night_gown",
            //         "item_id": '1474236000000520001',
            //         "rate": 80000,
            //         "quantity": 1
            //     },
            // ],
            samplePricing: [
                // {
                //     "category": "rate",
                //     "label": "15000",
                //     "value": 15000,
                // },
                {
                    "category": "rate",
                    "label": "25000",
                    "value": 25000,
                },
                {
                    "category": "rate",
                    "label": "35000",
                    "value": 35000,
                },
                {
                    "category": "rate",
                    "label": "40000",
                    "value": 40000,
                },
                {
                    "category": "rate",
                    "label": "65000",
                    "value": 65000,
                },

            ],
        }
    }

    componentDidMount() {
        console.log("tsc2 +++++++++++ componentDidMount");
        //this.getDropdownItemList();
        getShirtTypesToDisplay(this.setShirtTypeDropDown, "receipt_enter");
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

        this.props.updateOrderArray(this.props.arrayIndex, e.target.name, e.target.value);

    }

    handleOrderDetailsDropDownChanges = (value) => {
        console.log('entx9 You\'ve sss:', value);
        console.log('entx91 You\'ve selected:', value.value + " " + value.category+" stockItem:"+value.stockitem);

        let newState = {};
        newState[value.category] = value.value;

        this.setState(newState);

        //if (value.category === 'selectedItem') {
        if (value.category === 'shirtTypeId') {
           // let tempNew1 = { "item_id": value.item_id, "name": value.label };
            let tempNew1 = { "item_id": value.key, "name": value.label };
            this.setState({ item1: tempNew1 });

            //this.props.updateOrderArray(this.props.arrayIndex, "item1", tempNew1);

            //SET ITEM ID
            //this.props.updateOrderArray(this.props.arrayIndex, "item_id", value.item_id);
            this.props.updateOrderArray(this.props.arrayIndex, "item_id", value.key);

            //SET name
            this.props.updateOrderArray(this.props.arrayIndex, "name", value.label);

            //UPDATE PRICE ON STOCK ITEM
            if(value.stockitem == 'yes'){
                console.log("its a stock item:"+value.stockitem);

                this.setState({
                    shirtCost:value.shirttypebuycost
                })
            }else{
                console.log("its not a stock item:"+value.stockitem);
                this.setState({
                    shirtCost: ''
                })
            }

        } else if (value.category === 'rate') {
            // let tempNew1 = { "item_id": value.item_id, "name": value.label };
            // this.setState({ item1: tempNew1 });

            this.props.updateOrderArray(this.props.arrayIndex, "rate", value.value);

        }

    }

    setShirtTypeDropDown = (shirtTypes) => {
        console.log("gshtx21 +++++++:setShirtTypeDropDown");
        //console.log("gshtx22:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            loading: false, 
            items: shirtTypes
        })

    }

    getDropdownItemList = () => {
        axios.post(serverIp + 'billing/getListOfItemsToBill', {
            apiKey: "8320"
        })
            .then((response) => {
                console.log(response.data);

                console.log("tsc1 result:" + response.data.dropdownItems);

                if (response.data.dropdownItems) {

                    this.setState({ loading: false, 
                        items: response.data.dropdownItems });

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
            });
    }

    render() {
        return (
            this.state.loading ? <UiConsts.LoadingComponent /> :
                <div>
                    {/* <h3>Item #{this.props.arrayIndex + 1}</h3> */}
                    <Divider horizontal>Item #{this.props.arrayIndex + 1}</Divider>

                    {/* ITEM */}
                    <Select
                        name="form-field-name"
                        //value={this.state.selectedItem}
                        value={this.state.shirtTypeId}
                        options={this.state.items}
                        onChange={this.handleOrderDetailsDropDownChanges}
                        searchable={true}
                        clearable={false}
                    />
                    <br></br>

                    {/* Number Of Items */}
                    <Form.Field>
                        <label>Number Of Items</label>
                        <Form.Input
                            fluid
                            name={'quantity'}
                            //value={this.state.numItems1}
                            value={this.state.quantity}
                            icon='add user'
                            iconPosition='left'
                            placeholder='Num Items'
                            // onFocus={props.amp_logFieldClick}
                            onChange={this.handleTextInputChange}
                            type='number'
                        //error={props.formErrorFieldArray['name']}
                        />
                    </Form.Field>
                    {/* <br /> */}

                    {/* PRESET PRICING OPTIONS */}
                    <Select
                        name="form-field-name"
                        value={this.state.rate}
                        options={this.state.samplePricing}
                        onChange={this.handleOrderDetailsDropDownChanges}
                        searchable={false}
                        clearable={false}
                    />


                    {/* Price per item*/}
                    <Form.Field>
                        <label>Price per Item</label>
                        <Form.Input
                            fluid
                            name={'rate'}
                            value={this.state.priceItems1}
                            icon='add user'
                            iconPosition='left'
                            placeholder='Item Price'
                            // onFocus={props.amp_logFieldClick}
                            onChange={this.handleTextInputChange}
                            type='number'
                        //error={props.formErrorFieldArray['name']}
                        />
                    </Form.Field>

                    <Form.Field>
                        <label>Item Cost (How much did it to buy item)</label>
                        <Form.Input
                            fluid
                            name={'shirtCost'}
                            value={this.state.shirtCost}
                            icon='add user'
                            iconPosition='left'
                            placeholder='shirtCost'
                            // onFocus={props.amp_logFieldClick}
                            onChange={this.handleTextInputChange}
                            type='number'
                        //error={props.formErrorFieldArray['name']}
                        />
                    </Form.Field>

                    <Button type='Button' onClick={this.props.addItemToOrderItemsArray}> ADD ITEM</Button>

                </div>
        );
    }
}

export default RecItem;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/EnterReceipts/RecItem.js